// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  appVersion: 0,
  USERDATA_KEY: 0,
  apiUrl: '',
  isMockEnabled: true,
  reviewFormApiBaseUrl: 'https://dhsdevimcsa.dhs.state.ia.us',
  //reviewFormApiBaseUrl:'https://localhost:44308',
  dsnapApiBaseUrl: 'https://localhost:44308/'
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
